import React, { memo } from 'react';

import cx from 'classnames';

import { getPrefix } from 'detailsv2/LandingV2/utils';

import { useNavigationLinks } from './functions';
import s from './index.module.css';
import { ILinkProps, IWrapperProps } from './types';

export const LinkItem = memo(({ link, onClick, activePageId, isHidden = false }: ILinkProps) => {
  const { linkText, isActive } = useNavigationLinks(link, activePageId);
  const linkClasses = cx(s.link, getPrefix('landing-page-burger-nav-link'));
  const activeLinkClasses = cx(s.activeLink, getPrefix('landing-page-burger-nav-active-link'));
  const itemLineClasses = cx(s.itemLine, getPrefix('landing-page-burger-nav-link-line'));
  const activeItemLineClasses = cx(s.activeLinkLine, getPrefix('landing-page-burger-nav-active-link-line'));
  const itemDatesClasses = cx(s.itemDates, getPrefix('landing-page-burger-nav-link-dates'));

  return (
    <div onClick={onClick} className={cx(linkClasses, isActive && activeLinkClasses)}>
      <Wrapper hidden={isHidden}>
        <div className={s.textBlock}>
          <span className={cx(isActive && activeItemLineClasses, itemLineClasses)}></span>
          {linkText}
        </div>
        {!!link.sub && <div className={itemDatesClasses}>{link.sub}</div>}
      </Wrapper>
    </div>
  );
});

const Wrapper = ({ hidden, children }: IWrapperProps) => {
  if (hidden) return <s data-block>{children}</s>;
  return (
    <span data-block className={cx(s.linkText)}>
      {children}
    </span>
  );
};
